var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-window"},[_c('h2',[_vm._v(_vm._s(this.title))]),_c('i',{staticClass:"el-icon-close",attrs:{"title":"关闭"},on:{"click":() => this.$emit('close')}}),_c('main',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }